import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"1200px","min-height":"500px","margin":"0px auto","position":"relative"} }

import ItemTable from "@/views/globalSearch/moudle/itemTable.vue";
import MessageTable from "@/views/globalSearch/moudle/messageTable.vue";
import {ref, toRefs} from "vue";
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute()
let selectTagName = ref('政务服务办事大厅')
let selectListName = ref('zwfwbsdt')
let keyWord = ref('')

keyWord.value = route.query.keyWord as any
console.log(keyWord,"++++++++++++++++++++")


return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "no_banner",
      id: "no_banner"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ItemTable, {
        tagName: _unref(selectTagName),
        listName: _unref(selectListName),
        keyWord: _unref(keyWord)
      }, null, 8, ["tagName", "listName", "keyWord"]),
      _createVNode(_component_el_divider),
      _createVNode(MessageTable, { keyWord: _unref(keyWord) }, null, 8, ["keyWord"])
    ]),
    _createVNode(_component_Bottom)
  ]))
}
}

})